import { createFileRoute } from "@tanstack/react-router";

import { orgLoaderHandler } from "src/lib/orgLoaderHandler";
import { CoachAthleteMetricsPage } from "src/pages/CoachAthleteMetricsPage";
import { createOrganizationMetricsRepository } from "src/repositories/metrics/createOrganizationMetricsRepository";

export const Route = createFileRoute(
  "/_auth/_coach/orgs/$slug/athletes/$athleteId/_tabs/metrics/",
)({
  component: CoachAthleteMetricsPage,
  ssr: true,
  async loader({ context, params }) {
    return orgLoaderHandler(
      { queryClient: context.queryClient, slug: params.slug },
      async ({ organization }) => ({
        data: await context.queryClient.query({
          ...createOrganizationMetricsRepository(
            organization.id,
          ).summaryOptions(params.athleteId),
          staleTime: "static",
        }),
      }),
    );
  },
});
